
import { ActionIcon, Button, Grid, Group, Paper } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import React from 'react';
import { UPDATE_COMPANY_FIELDS, GET_FIELDS } from '../services/companies';
import { FaPlus, FaTrash } from 'react-icons/fa';
import InputField, { InputFieldTypes } from '../components/input_field';
import { useLanguage } from '../contexts/language.context';

export default function FieldsPage() {
    const [fields, setFields] = React.useState<any>(null);
    const [loadingSave, setLoadingSave] = React.useState(false);

    const { str } = useLanguage();

    const handleSave = () => {
        setLoadingSave(true)
        UPDATE_COMPANY_FIELDS(fields)
            .then(() => {
                setLoadingSave(false)
                notifications.show({ message: str("FIELDS.SAVED"), color: "green" })
            })
            .catch(err => {
                setLoadingSave(false)
                notifications.show({ title: "Ops.", message: err.message, color: 'red' })
            })
    }

    const loadData = () => {
        GET_FIELDS()
            .then((f) => {
                setFields(f)
            })
            .catch(err => {
                notifications.show({ title: "Ops.", message: err.message, color: 'red' })
            })
    }

    const handleChangeField = index => dt => {
        setFields(f =>
            f.map((cf, j) => index === j ? { ...cf, ...dt } : cf)
        )
    }

    React.useEffect(() => { loadData() }, [])

    return <>
        <Group justify="flex-end" mt="md">
            <Button size="sm" leftSection={<FaPlus />}
                color="gray"
                variant='outline'
                onClick={() => setFields([...(fields || []), { type: "string" }])}>{str("FIELDS.ADD")}</Button>
        </Group>

        {(fields || []).map((field, i) => <Paper p="md" shadow='xs' mb="xs" mt="xs">
            <Grid align='flex-end'>
                <Grid.Col span={{ base: 12, sm: 4 }}>
                    <InputField
                        title={str("TYPE")}
                        name="type"
                        fieldType={InputFieldTypes.SELECT}
                        options={[
                            { label: str("FIELDS.TYPES.TEXT"), value: "string" },
                            // { label: str("FIELDS.TYPES.DATE"), value: "date" },
                            // { label: str("FIELDS.TYPES.DATETIME"), value: "datetime" },
                            // { label: str("FIELDS.TYPES.TIME"), value: "time" },
                        ]}
                        value={field.type}
                        onChange={handleChangeField(i)}
                    />
                </Grid.Col>
                <Grid.Col span={{ base: 12, sm: 4 }}>
                    <InputField
                        title={str("TITLE")}
                        name="title"
                        value={field.title}
                        onChange={handleChangeField(i)}
                    />
                </Grid.Col>
                <Grid.Col span={{ base: 12, sm: 3 }}></Grid.Col>
                <Grid.Col span={{ base: 12, sm: 1 }}>
                    <ActionIcon color="gray" variant='light' onClick={() => setFields(f => (f || []).filter((c, j) => i !== j))}>
                        <FaTrash />
                    </ActionIcon>
                </Grid.Col>
            </Grid>
        </Paper>)}

        <Group justify="flex-end" mt="md">
            <Button size="md" onClick={handleSave} loading={loadingSave}>{str("FIELDS.SAVE")}</Button>
        </Group>
    </>
}
